// // src/services/apiService.js
// const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

// class ApiService {
//   constructor() {
//     this.token = localStorage.getItem("authToken");
//   }

//   setToken(token) {
//     this.token = token;
//     if (token) {
//       localStorage.setItem("authToken", token);
//     } else {
//       localStorage.removeItem("authToken");
//     }
//   }

//   getHeaders() {
//     const headers = {
//       "Content-Type": "application/json",
//     };

//     if (this.token) {
//       headers["Authorization"] = `Bearer ${this.token}`;
//     }

//     return headers;
//   }

//   async request(endpoint, options = {}) {
//     const url = `${API_BASE_URL}${endpoint}`;
//     const config = {
//       headers: this.getHeaders(),
//       ...options,
//     };

//     try {
//       const response = await fetch(url, config);

//       // Check if response is HTML (likely a 404 page)
//       const contentType = response.headers.get("content-type");
//       if (contentType && contentType.includes("text/html")) {
//         throw new Error(
//           `Server returned HTML instead of JSON. Check if the endpoint ${endpoint} exists on the backend.`
//         );
//       }

//       if (!response.ok) {
//         let errorMessage = `HTTP error! status: ${response.status}`;
//         let errorCode = "HTTP_ERROR";

//         try {
//           const error = await response.json();
//           errorMessage = error.error || error.message || errorMessage;
//           errorCode = error.code || errorCode;

//           // Handle specific authentication errors
//           if (response.status === 401) {
//             errorCode = "UNAUTHORIZED";
//             errorMessage = "Authentication required";
//             // Clear invalid token
//             this.setToken(null);
//           } else if (response.status === 403) {
//             errorCode = "FORBIDDEN";
//             errorMessage =
//               error.error || "Access denied - invalid or expired token";
//             // Clear invalid token
//             this.setToken(null);
//           }
//         } catch (jsonError) {
//           // If we can't parse the error as JSON, use the status text
//           errorMessage = response.statusText || errorMessage;
//         }

//         const apiError = new Error(errorMessage);
//         apiError.status = response.status;
//         apiError.code = errorCode;
//         throw apiError;
//       }

//       // Handle no content responses
//       if (response.status === 204) {
//         return null;
//       }

//       return await response.json();
//     } catch (error) {
//       // Enhance error messages for common connection issues
//       if (
//         error.name === "TypeError" &&
//         error.message.includes("Failed to fetch")
//       ) {
//         const enhancedError = new Error(
//           "Cannot connect to backend server. Please ensure the server is running on http://localhost:5000"
//         );
//         enhancedError.code = "CONNECTION_FAILED";
//         throw enhancedError;
//       }

//       if (error.message.includes("ERR_CONNECTION_REFUSED")) {
//         const enhancedError = new Error(
//           "Connection refused. Backend server is not running on port 5000."
//         );
//         enhancedError.code = "CONNECTION_REFUSED";
//         throw enhancedError;
//       }

//       // If token was cleared due to auth error, notify about re-authentication
//       if (error.status === 401 || error.status === 403) {
//         const authError = new Error("Please sign in again");
//         authError.code = "REAUTHENTICATION_REQUIRED";
//         authError.originalError = error;
//         throw authError;
//       }

//       console.error(`API request failed: ${endpoint}`, error);
//       throw error;
//     }
//   }

//   // Auth methods
//   async authenticateWithGoogle(googleToken) {
//     // Validate token format
//     if (!googleToken || typeof googleToken !== "string") {
//       throw new Error("Invalid Google token: Token must be a string");
//     }

//     // Check if it's a proper JWT (should have 3 segments)
//     const segments = googleToken.split(".");
//     if (segments.length !== 3) {
//       throw new Error(
//         `Invalid Google token format: Expected JWT with 3 segments, got ${segments.length}`
//       );
//     }

//     try {
//       const response = await this.request("/auth/google", {
//         method: "POST",
//         body: JSON.stringify({ token: googleToken }),
//       });

//       if (response.token) {
//         this.setToken(response.token);
//       }

//       return response;
//     } catch (error) {
//       // Don't set token if authentication failed
//       this.setToken(null);
//       throw error;
//     }
//   }

//   async signOut() {
//     this.setToken(null);
//     return Promise.resolve();
//   }

//   // User methods
//   async getUsers() {
//     return this.request("/users");
//   }

//   // List methods
//   async getLists() {
//     return this.request("/lists");
//   }

//   async createList(listData) {
//     return this.request("/lists", {
//       method: "POST",
//       body: JSON.stringify(listData),
//     });
//   }

//   async updateList(listId, listData) {
//     return this.request(`/lists/${listId}`, {
//       method: "PUT",
//       body: JSON.stringify(listData),
//     });
//   }

//   async deleteList(listId) {
//     return this.request(`/lists/${listId}`, {
//       method: "DELETE",
//     });
//   }

//   // Task methods
//   async getTasks(listId) {
//     return this.request("/tasks").then((tasks) =>
//       tasks.filter((task) => task.listId === listId)
//     );
//   }

//   async createTask(listId, taskData) {
//     return this.request("/tasks", {
//       method: "POST",
//       body: JSON.stringify({ ...taskData, listId }),
//     });
//   }

//   async updateTask(listId, taskId, taskData) {
//     return this.request(`/tasks/${taskId}`, {
//       method: "PUT",
//       body: JSON.stringify(taskData),
//     });
//   }

//   async deleteTask(listId, taskId) {
//     return this.request(`/tasks/${taskId}`, {
//       method: "DELETE",
//     });
//   }

//   // Activity methods
//   async getActivities(listId) {
//     return this.request("/activities").then((activities) =>
//       activities.filter((activity) => activity.listId === listId)
//     );
//   }

//   // Notification methods
//   async getNotifications() {
//     return this.request("/notifications");
//   }

//   async updateNotification(notificationId, updates) {
//     return this.request(`/notifications/${notificationId}`, {
//       method: "PUT",
//       body: JSON.stringify(updates),
//     });
//   }

//   // Invitation methods
//   async inviteMember(listId, email, role) {
//     return this.request(`/lists/${listId}/invitations`, {
//       method: "POST",
//       body: JSON.stringify({ email, role }),
//     });
//   }

//   async getInvitation(listId, email) {
//     const params = new URLSearchParams({ listId, email });
//     return this.request(`/invitations?${params}`);
//   }
// }

// const apiService = new ApiService();
// export default apiService;

// src/services/apiService.js
// Use full URL in development to avoid proxy issues
// In production, set REACT_APP_API_URL environment variable
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Always use direct URL in development (browser environment)
  // Check if we're in development by checking the port (React dev server uses 3000)
  if (typeof window !== 'undefined') {
    const port = window.location.port;
    // If running on port 3000 (React dev server), always use localhost:5000 for API
    if (port === '3000' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:5000/api';
    }
  }
  // Fallback to relative path for production
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

// Log the API base URL on initialization
console.log('[API Service] Initialized with base URL:', API_BASE_URL);
console.log('[API Service] Window location:', typeof window !== 'undefined' ? window.location.href : 'N/A');

class ApiService {
  constructor() {
    this.token = localStorage.getItem("authToken");
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem("authToken", token);
    } else {
      localStorage.removeItem("authToken");
    }
  }

  getHeaders() {
    const headers = {
      "Content-Type": "application/json",
    };

    if (this.token) {
      headers["Authorization"] = `Bearer ${this.token}`;
    }

    return headers;
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const { headers: customHeaders, body, method, ...restOptions } = options;
    
    const config = {
      method: method || 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        ...this.getHeaders(),
        ...(customHeaders || {}),
      },
      ...restOptions,
    };

    // Add body if provided
    if (body) {
      config.body = body;
    }

    try {
      console.log(`[API] ${config.method} ${url}`);
      const response = await fetch(url, config);

      // Check if response is HTML (likely a 404 page)
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("text/html")) {
        throw new Error(
          `Server returned HTML instead of JSON. Check if the endpoint ${endpoint} exists on the backend.`
        );
      }

      if (!response.ok) {
        let errorMessage = `HTTP error! status: ${response.status}`;
        let errorCode = "HTTP_ERROR";

        try {
          const error = await response.json();
          errorMessage = error.error || error.message || errorMessage;
          errorCode = error.code || errorCode;

          // Handle specific authentication errors
          if (response.status === 401) {
            errorCode = "UNAUTHORIZED";
            errorMessage = "Authentication required";
            // Clear invalid token
            this.setToken(null);
          } else if (response.status === 403) {
            errorCode = "FORBIDDEN";
            errorMessage =
              error.error || "Access denied - invalid or expired token";
            // Clear invalid token
            this.setToken(null);
          }
        } catch (jsonError) {
          // If we can't parse the error as JSON, use the status text
          errorMessage = response.statusText || errorMessage;
        }

        const apiError = new Error(errorMessage);
        apiError.status = response.status;
        apiError.code = errorCode;
        throw apiError;
      }

      // Handle no content responses
      if (response.status === 204) {
        return null;
      }

      return await response.json();
    } catch (error) {
      // Log the full error for debugging
      console.error(`[API] Request failed for ${endpoint}:`, {
        name: error.name,
        message: error.message,
        stack: error.stack,
        url: url
      });

      // Enhance error messages for common connection issues
      if (
        error.name === "TypeError" &&
        (error.message.includes("Failed to fetch") || 
         error.message.includes("NetworkError") ||
         error.message.includes("Network request failed"))
      ) {
        // Check if it's actually a CORS issue
        const isCorsIssue = error.message.includes("CORS") || 
                           error.message.includes("Access-Control");
        
        const enhancedError = new Error(
          isCorsIssue 
            ? "CORS error: Backend server may not be allowing requests from this origin. Check CORS configuration."
            : "Cannot connect to backend server. Please ensure the server is running on http://localhost:5000"
        );
        enhancedError.code = isCorsIssue ? "CORS_ERROR" : "CONNECTION_FAILED";
        enhancedError.originalError = error;
        throw enhancedError;
      }

      if (error.message.includes("ERR_CONNECTION_REFUSED")) {
        const enhancedError = new Error(
          "Connection refused. Backend server is not running on port 5000."
        );
        enhancedError.code = "CONNECTION_REFUSED";
        throw enhancedError;
      }

      // If token was cleared due to auth error, notify about re-authentication
      if (error.status === 401 || error.status === 403) {
        const authError = new Error("Please sign in again");
        authError.code = "REAUTHENTICATION_REQUIRED";
        authError.originalError = error;
        throw authError;
      }

      // Re-throw the original error with more context
      error.url = url;
      throw error;
    }
  }

  // Auth methods
  async authenticateWithGoogle(googleToken) {
    // Validate token format
    if (!googleToken || typeof googleToken !== "string") {
      throw new Error("Invalid Google token: Token must be a string");
    }

    // Check if it's a proper JWT (should have 3 segments)
    const segments = googleToken.split(".");
    if (segments.length !== 3) {
      throw new Error(
        `Invalid Google token format: Expected JWT with 3 segments, got ${segments.length}`
      );
    }

    try {
      console.log(`[API] Authenticating with Google`);
      console.log(`[API] Base URL: ${API_BASE_URL}`);
      console.log(`[API] Full URL will be: ${API_BASE_URL}/auth/google`);
      console.log(`[API] Token length: ${googleToken.length}`);
      
      const response = await this.request("/auth/google", {
        method: "POST",
        body: JSON.stringify({ token: googleToken }),
      });
      
      console.log(`[API] Authentication response received:`, response);

      if (response.token) {
        this.setToken(response.token);
      }

      return response;
    } catch (error) {
      console.error("[API] Google authentication error:", error);
      console.error("[API] Error details:", {
        name: error.name,
        message: error.message,
        code: error.code,
        url: error.url
      });
      // Don't set token if authentication failed
      this.setToken(null);
      throw error;
    }
  }

  async signOut() {
    this.setToken(null);
    return Promise.resolve();
  }

  // User methods
  async getUsers() {
    return this.request("/users");
  }

  // List methods
  async getLists() {
    return this.request("/lists");
  }

  async createList(listData) {
    return this.request("/lists", {
      method: "POST",
      body: JSON.stringify(listData),
    });
  }

  async updateList(listId, listData) {
    return this.request(`/lists/${listId}`, {
      method: "PUT",
      body: JSON.stringify(listData),
    });
  }

  async deleteList(listId) {
    return this.request(`/lists/${listId}`, {
      method: "DELETE",
    });
  }

  // Task methods
  async getTasks(listId) {
    return this.request("/tasks").then((tasks) =>
      tasks.filter((task) => task.listId === listId)
    );
  }

  async createTask(listId, taskData) {
    return this.request("/tasks", {
      method: "POST",
      body: JSON.stringify({ ...taskData, listId }),
    });
  }

  async updateTask(listId, taskId, taskData) {
    return this.request(`/tasks/${taskId}`, {
      method: "PUT",
      body: JSON.stringify(taskData),
    });
  }

  async deleteTask(listId, taskId) {
    return this.request(`/tasks/${taskId}`, {
      method: "DELETE",
    });
  }

  // Activity methods
  async getActivities(listId) {
    return this.request("/activities").then((activities) =>
      activities.filter((activity) => activity.listId === listId)
    );
  }

  // Notification methods
  async getNotifications() {
    return this.request("/notifications");
  }

  async updateNotification(notificationId, updates) {
    return this.request(`/notifications/${notificationId}`, {
      method: "PUT",
      body: JSON.stringify(updates),
    });
  }

  async markNotificationAsRead(notificationId) {
    return this.request(`/notifications/${notificationId}/read`, {
      method: "PUT",
    });
  }

  async markAllNotificationsAsRead() {
    return this.request("/notifications/mark-all-read", {
      method: "PUT",
    });
  }

  async markTopNotificationsAsRead() {
    return this.request("/notifications/mark-top-read", {
      method: "PUT",
    });
  }

  async deleteNotification(notificationId) {
    return this.request(`/notifications/${notificationId}`, {
      method: "DELETE",
    });
  }

  // Invitation methods
  async inviteMember(listId, email, role) {
    return this.request(`/lists/${listId}/invitations`, {
      method: "POST",
      body: JSON.stringify({ email, role }),
    });
  }

  async getInvitation(listId, email) {
    const params = new URLSearchParams({ listId, email });
    return this.request(`/invitations?${params}`);
  }
}

const apiService = new ApiService();
export default apiService;
